import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    Card,
    CardBody,
    CardHeader,
    Col,
    Container,
    Row,
    Spinner,
} from "reactstrap";
import { getDashboardStats } from "../../store/actions/MomentosActions";

const Dashboard = () => {
    const dispatch = useDispatch();
    const { uid, user } = useSelector((state) => state.authUser);
    const { dashboard, loading } = useSelector((state) => state.momentos);
    console.log(user);
    useEffect(() => {
        dispatch(getDashboardStats(uid));
    }, []);

    return (
        <Container fluid>
            <h1 className="text-center pt-5 pb-3">Dashboard</h1>
            {loading ? (
                <Row className="justify-content-center">
                    <Spinner size="sm" />
                </Row>
            ) : (
                <Container className="mt-5">
                    <Row>
                        <Col md="12">
                            <Card className="p-4  mb-3 create_momento-card ">
                                <Row>
                                    <Col xs="6" className="mb-3 mt-3">
                                        {" "}
                                        <p className="mb-0">
                                            <strong>Email:</strong>
                                        </p>
                                    </Col>
                                    <Col xs="6" className="mb-3 mt-3">
                                        {" "}
                                        <p className="mb-0">
                                            <strong>{user?.email}</strong>
                                        </p>
                                    </Col>
                                    <Col xs="6" className="mb-3">
                                        {" "}
                                        <p className="mb-0">
                                            <strong>Athlete ID:</strong>
                                        </p>
                                    </Col>
                                    <Col xs="6" className="mb-3">
                                        <p className="mb-0">
                                            <strong>{user?.athleteID}</strong>
                                        </p>
                                    </Col>
                                    <Col xs="6" className="mb-3">
                                        {" "}
                                        <p className="mb-0">
                                            <strong>Total Momento:</strong>
                                        </p>
                                    </Col>
                                    <Col xs="6" className="mb-3">
                                        <p className="mb-0">
                                            <strong>
                                                {user?.momentoCount || 0}
                                            </strong>
                                        </p>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                        <Col>
                            <Card className=" px-4 py-4 create_momento-card d-flex flex-row justify-content-around align-content-center">
                                <p className="mb-0">
                                    <strong>Sold Mementos</strong>
                                </p>
                                <p className="mb-0">
                                    <strong>
                                        {dashboard?.momentoSold || 0.0}
                                    </strong>
                                </p>
                            </Card>
                        </Col>

                        <Col>
                            <Card className=" px-4 py-4 create_momento-card d-flex flex-row justify-content-around align-content-center">
                                <p className="mb-0">
                                    <strong>Total Earnings</strong>
                                </p>
                                <p className="mb-0">
                                    <strong>
                                        $
                                        {dashboard?.earnings
                                            ? Number(
                                                  dashboard?.earnings
                                              ).toFixed(2)
                                            : 0.0}
                                    </strong>
                                </p>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            )}
        </Container>
    );
};

export default Dashboard;
